export { IFrameDialog } from './IframeDialog';
